import ChatMember from 'entities/ChatMember';
import Collection from 'lib/Collection';
// @ts-ignore
import Subscriber from 'entities/Subscriber';
// @ts-ignore
import User from 'entities/User';

class ChatMembers extends Collection<ChatMember> {
  initialize() {
    // @ts-ignore weight init, keeping cuz legacy
    this.model = ChatMember;
  }

  static buildChatMember(user: User | Subscriber): ChatMember {
    return new ChatMember({
      id: user.id,
      uuid: user.getUuid(),
      name: user.getSignature() || user.getName(),
      role: user.getRole(),
      office_hours: user.getOfficeHours(),
      contactability_status: user.getContactabilityStatus(),
      color: user.getColor(),
      initials: user.getInitials(),
    });
  }
}

export default ChatMembers;
